import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var DrawingTool = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 22.17C2 11.034 11.07 2 22.27 2a20.25 20.25 0 0 1 10.227 2.75 1 1 0 0 0 1.006-1.727A22.25 22.25 0 0 0 22.27 0C9.975 0 0 9.921 0 22.17c0 5.051 1.699 9.71 4.557 13.438a1 1 0 0 0 1.587-1.216A20.012 20.012 0 0 1 2 22.169Zm32.638-10.22-2.102 2.102 4.242 4.242 2.102-2.102a3 3 0 0 0-4.242-4.242Zm-1.414-1.414-2.796 2.795-.014.013-19.973 19.974a.863.863 0 0 0-.023.024.989.989 0 0 0-.359.492l-2.831 8.504a1 1 0 0 0 1.264 1.264l8.504-2.831a.99.99 0 0 0 .493-.36l.013-.012.01-.01L36.76 21.142l3.536-3.535a5 5 0 0 0-7.072-7.071ZM12.562 34.025l18.54-18.54 4.243 4.243-18.54 18.54-4.243-4.243Zm2.266 5.36-5.071 1.689 1.688-5.072 3.383 3.383ZM22 43a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H23a1 1 0 0 1-1-1Zm16-16a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5Zm-9 8a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H30a1 1 0 0 1-1-1Z"
  }));
});
DrawingTool.displayName = 'DrawingTool';
DrawingTool.defaultProps = {
  'aria-label': 'DrawingTool'
};
export default DrawingTool;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/DrawingTool.js
// module id = 3146
// module chunks = 11